<template>
    <form class="w-100">
        <div class="form-group position-relative">
            <input id="search-input" class="form-control" type="text" placeholder="Search by tournament or golf course" :value="searchText" @input="search" autocomplete="off">
            <tournament-results :results="searchResults" :query="searchText" :isSearching="isSearching" :showNoResults="showNoResults"></tournament-results>
        </div>
        <div class="form-group">
            <button class="btn btn-success w-100" @click.prevent="submit">Go</button>
        </div>
    </form>
</template>

<script>
    import TournamentResults from './TournamentResults';
    import _debounce from 'lodash/debounce';
    import axios from 'axios';

    export default {
        components: {TournamentResults},
        data() {
            return {
                searchText: '',
                showNoResults: false,
                searchResults: [],
                isSearching: false,
                selectedTournament: null
            }
        },
        mounted() {
          this.$on('tournamentSelection', (tournament) => {
              this.searchText = tournament.name;
              this.selectedTournament = tournament;
          })
        },
        methods: {
            submit() {
                if(!this.selectedTournament) {
                    if(this.searchText.length) {
                        window.openModal('Error', 'Tournament not found, please try searching again', 'alert');
                    } else {
                        window.openModal('Error', 'Please search for and select a tournament to continue', 'alert');
                    }
                } else {
                    if (this.selectedTournament.status === 'betting_open') {
                        window.location.href = `${window.location.href}getstarted/name/tournament/${this.selectedTournament.id}`;
                    } else {
                        window.location.href = `${window.location.href}live-odds/${this.selectedTournament.id}`;
                    }
                }
            },
            search(event) {
                this.searchText = event.target.value;
                this.searchResults = [];
                this.showNoResults = false;
                _debounce(() => {
                    if(this.searchText.length > 3 && !this.isSearching) {
                        this.isSearching = true;
                        axios.get(`/api/tournamentsearch?s=${this.searchText}`)
                            .then((response) => {
                                this.isSearching = false;
                                if(response.data && response.data.length) {
                                    this.searchResults = response.data;
                                } else {
                                    this.showNoResults = true;
                                }
                            })
                            .catch((error) => {
                                // This is intentionally left to show me errors in PRD ¯\_(ツ)_/¯
                                console.log(error);
                                window.openModal('Error', 'An unknown error has occurred', 'alert');
                                this.isSearching = false;
                            });
                    }
                }, 250)()
            }
        }
    }
</script>
